// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"075dd277","594":"9632948a"}[chunkId] + ".chunk.js";
};